/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ItineratorError, ItineratorGetRewardsParams, ItineratorReward, ItineratorRewardList } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Rewards<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Reward
   * @name GetRewards
   * @summary List all rewards
   * @request GET:/rewards
   * @secure
   */
  getRewards = (query?: ItineratorGetRewardsParams, params: RequestParams = {}) =>
    this.request<ItineratorRewardList, ItineratorError>({
      path: `/rewards`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Reward
   * @name GetRewardBySlug
   * @summary Find a reward by slug
   * @request GET:/rewards/{slug}
   * @secure
   */
  getRewardBySlug = (slug: string | number, params: RequestParams = {}) =>
    this.request<ItineratorReward, ItineratorError>({
      path: `/rewards/${slug}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
